import { transformHuggg } from 'utilities/huggg';
import { transformSuperhuggg } from 'utilities/superhuggg';
import AuthService from 'services/AuthService';

const auth = new AuthService();

let defaultState = {
  ...transformHuggg({}),
  auth: {
    status: {
      loading: false,
      loggedIn: auth.getLoggedInStatus(),
      error: null,
      userId: auth.getUserId() || null
    },
    sms: {
      activationCode: null,
      challengeID: null,
      tryCount: 0,
      step: 'begin'
    }
  },
  brand: { brand: {} },
  voucher: { error: null, isGenerating: false },
  guidedChoice: {
    history: [],
    config: {}
  },
  selectedSegment: {
    segment: null
  },
  tillo: {
    brand: {
      name: null,
      logoUrl: null,
      giftCardUrl: null
    },
    status: {
      loaded: false,
      loading: false
    }
  },
  prepaidCard: {
    otpDelay: 0,
    generatingOtpError: null,
    loading: false,
    fetchCardDataError: null,
    isFetchingCardData: false,
    cardData: null,
    fetchSensitiveCardDataError: null,
    isFetchingSensitiveCardData: false,
    sensitiveCardData: null,
    reportMisuseError: null,
    isReportingMisuse: false,
    formData: {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      dateOfBirth: {
        date: '',
        month: '',
        year: ''
      },
      postalAddress: {
        addressLine1: '',
        addressLine2: '',
        city: '',
        postcode: '',
        // Due to some current limitiations on initialDate in the react-component form, this country data needs to be hard-coded. The form is currently set to GBR anyway.
        country: 'United Kingdom',
        countryIso: 'GBR'
      }
    }
  },
  pin4: { error: null, isSending: false, resendDelay: null },
  hugggs: {
    allIds: [],
    byId: {},
    status: {
      loaded: false,
      loading: false
    }
  },
  redeem: {
    isFirstRedeemed: false,
    redeeming: false,
    redemption: null,
    redeemError: null
  },
  error: {},
  reaction: {
    loadingEmoji: false,
    loadingComment: false,
    loadingEmojiError: '',
    loadingCommentError: '',
    emoji: '',
    name: '',
    message: ''
  }
};

if (window.hugggState && window.hugggState.huggg) {
  defaultState = {
    ...defaultState,
    ...transformHuggg(window.hugggState.huggg)
  };
}

if (window.hugggState && window.hugggState.superhuggg) {
  defaultState = {
    ...defaultState,
    ...transformSuperhuggg(window.hugggState.superhuggg)
  };
}

// Inject product state if available (for product preview pages)
if (window.productState) {
  defaultState = {
    ...defaultState,
    product: {
      product: window.productState.product || null,
      segments: window.productState.segments || [],
      loading: false,
      segmentsLoading: false,
      error: null,
      segmentsError: null
    }
  };
}

export default () => defaultState;
